var state = {
    title: 'Welcome',
    items: [
        'logo',
        'title',
        'account'
    ],
    headerHeight: 0,
};
var getters = {
    getTitle: function (state) {
        return state.title;
    },
    getHeaderHeight: function (state) {
        return state.headerHeight;
    },
    getItems: function (state) {
        return state.items;
    }
};
var actions = {
    setTitle: function (_a, title) {
        var commit = _a.commit;
        commit('setTitle', title);
    },
    setHeaderHeight: function (_a, headerHeight) {
        var commit = _a.commit;
        commit('setHeaderHeight', headerHeight);
    },
    setItems: function (_a, items) {
        var commit = _a.commit;
        commit('setItems', items);
    },
};
var mutations = {
    setTitle: function (state, title) {
        state.title = title;
    },
    setHeaderHeight: function (state, headerHeight) {
        state.headerHeight = headerHeight;
    },
    setItems: function (state, items) {
        state.items = items;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/header.store.ts
// module id = null
// module chunks = 